import { Component, Host, Prop, getAssetPath, h } from '@stencil/core';

@Component({
  tag: 'sportsline-analysis',
  styleUrl: 'sportsline-analysis.css',
  shadow: true,
})
export class SportslinePickAnalysis {
  /**
   * The analysis text to be displayed in the card.
   */
  @Prop() analysis: string;

  private get getIsLongAnalysis() {
    return this.analysis?.length > 240;
  }

  render() {
    return (
      <Host>
        {this.getIsLongAnalysis && <input type="checkbox" class="sportsline-analysis__analysis-checkbox" id="analysis-toggle-checkbox" />}
        <div class={`sportsline-analysis__analysis-text ${this.getIsLongAnalysis ? 'sportsline-analysis__analysis-text-clamp' : ''}`}>{this.analysis}</div>
        {this.getIsLongAnalysis && (
          <label htmlFor="analysis-toggle-checkbox">
            <div class="sportsline-analysis__analysis-toggle">
              <img width={14} src={getAssetPath('./assets/images/expand-analysis-arrow.svg')} />
            </div>
          </label>
        )}
      </Host>
    );
  }
}
